import React from 'react';
import { GripVertical } from 'lucide-react';

// Blocco di testo posizionato in ASSOLUTO nella pagina A4 (tela libera).
// La logica di trascinamento (fluida, con overlay flottante) è orchestrata dal
// PaperMenuEditor: questo componente è puramente presentazionale e notifica solo
// l'inizio del drag tramite onDragStart(e, blockId, html).
//
// props:
//  - block: { id, role, ... }
//  - html: HTML pre-renderizzato del contenuto
//  - left, top, width: posizione/dimensione in px A4 (dentro il canvas scalato)
//  - selected: bool
//  - onDragStart(e, blockId, html)
export const DraggableTextBlock = ({ block, html, left, top, width, selected, onDragStart }) => (
  <div
    onPointerDown={(e) => onDragStart(e, block.id, html)}
    style={{
      position: 'absolute',
      left,
      top,
      width,
      cursor: 'grab',
      touchAction: 'none',
      outline: selected ? '2px solid rgba(59,130,246,.95)' : '1px dashed rgba(0,0,0,.14)',
      outlineOffset: 2,
      borderRadius: 3,
      background: selected ? 'rgba(59,130,246,.05)' : 'transparent',
      transition: 'outline-color .12s ease, background-color .12s ease',
    }}
    data-testid={`paper-block-${block.id}`}
  >
    {selected && (
      <div
        style={{
          position: 'absolute', top: -11, left: -11, width: 22, height: 22, borderRadius: 6,
          background: '#3b82f6', color: '#fff', display: 'flex', alignItems: 'center',
          justifyContent: 'center', boxShadow: '0 1px 4px rgba(0,0,0,.3)', pointerEvents: 'none',
        }}
      >
        <GripVertical size={14} />
      </div>
    )}
    <div style={{ pointerEvents: 'none' }} dangerouslySetInnerHTML={{ __html: html }} />
  </div>
);

export default DraggableTextBlock;
